<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="template-list-container">
  <div class="template-list-toolbar">
    <div class="template-list-filters">
      <p-dropdown
        [options]="[{label: 'All Regions', value: null}, ...regionOptions]"
        [(ngModel)]="regionFilter"
        (onChange)="applyFilters()"
        optionLabel="label"
        optionValue="value"
        placeholder="Filter by Region"
        [showClear]="true"
        styleClass="template-filter-dd">
      </p-dropdown>
    </div>
    <div class="template-list-actions">
      <button pButton pRipple
        class="p-button-outlined p-button-secondary"
        label="Clone Existing Template"
        icon="pi pi-clone"
        style="margin-right:0.5rem"
        (click)="messageService.add({severity:'info', summary:'Select a template row to clone'})">
      </button>
      <button pButton pRipple
        class="p-button btn-blue"
        label="New Template +"
        (click)="onNewTemplate()">
      </button>
    </div>
  </div>

  <p-table
    #pt
    [value]="templates"
    [lazy]="true"
    (onLazyLoad)="loadLazy($event)"
    dataKey="taskId"
    selectionMode="single"
    (onRowSelect)="onRowSelect($event)"
    [loading]="loading"
    [paginator]="true"
    [rows]="50"
    [rowsPerPageOptions]="[25, 50, 100]"
    [totalRecords]="recordTotal"
    showCurrentPageReport="true"
    currentPageReportTemplate="{totalRecords} templates. Page {currentPage} of {totalPages}"
    sortMode="multiple"
    [multiSortMeta]="multiSortMeta"
    styleClass="p-datatable-striped"
    [autoLayout]="true">

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">Name <p-sortIcon field="name"></p-sortIcon></th>
        <th pSortableColumn="region">Region <p-sortIcon field="region"></p-sortIcon></th>
        <th pSortableColumn="priorityTier">Priority <p-sortIcon field="priorityTier"></p-sortIcon></th>
        <th>Service Tag</th>
        <th pSortableColumn="estimatedTotalCost">Est. Cost <p-sortIcon field="estimatedTotalCost"></p-sortIcon></th>
        <th pSortableColumn="isActive">Active <p-sortIcon field="isActive"></p-sortIcon></th>
        <th pSortableColumn="createDate">Created <p-sortIcon field="createDate"></p-sortIcon></th>
        <th>Actions</th>
      </tr>
      <tr>
        <th><input pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'contains')" style="width:100%"></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-tmpl>
      <tr [pSelectableRow]="tmpl" style="cursor:pointer">
        <td><strong>{{tmpl.name}}</strong></td>
        <td>{{getRegionLabel(tmpl.region)}}</td>
        <td>{{getPriorityLabel(tmpl.priorityTier)}}</td>
        <td>
          <span *ngFor="let tag of tmpl.taskTagJoins" class="p-tag p-tag-info" style="margin-right:3px">
            {{tag.tag?.name || tag.tagName}}
          </span>
        </td>
        <td>{{tmpl.estimatedTotalCost | currency:'USD'}}</td>
        <td>
          <span [class]="tmpl.isActive ? 'p-tag p-tag-success' : 'p-tag p-tag-danger'">
            {{tmpl.isActive ? 'Active' : 'Inactive'}}
          </span>
        </td>
        <td>{{tmpl.createDate | date:'MM/dd/yyyy'}}</td>
        <td>
          <button pButton pRipple icon="pi pi-clone" class="p-button-text p-button-sm"
            title="Clone template"
            (click)="onCloneTemplate(tmpl, $event)">
          </button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" style="text-align:center; padding:2rem;">No templates found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
